export class SearchFeedbackDashboardData {
    allClients: boolean;
    clientIds: number[];
    dateFrom?: Date;
    dateTo?: Date;
    /** Brands to restrict to; empty or absent means every brand the user may see. */
    companyIds?: number[];
    /** 'SESSION' or 'TUITION'; null or absent for both. */
    surveyType?: string | null;
    /** Tutor (Orbit candidate id); null or absent for every tutor. */
    tutorId?: number | null;

    constructor() {}
}